import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResourcesService } from '../services/resources.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-add-response',
  templateUrl: './add-response.component.html',
  styleUrls: ['./add-response.component.css']
})
export class AddResponseComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data:any, public _resourcesServices: ResourcesService, public log: LogService) { }

  public response = "";
  public allResponses = [];
  public constr;
  public emptyResponse = false;
  public spinner = true;

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Add Response",
      details: `Accessed Add Response`,
    }).subscribe(data => { });
    this.getAllResponses();
  }
  
  getAllResponses () {
    let obj = {course_id: this.data.course_id, resource_question_id: this.data.resource_question_id}
    this._resourcesServices.getQuestionResponse(obj).subscribe(data => {
      this.allResponses = data;
      if (this.allResponses.length <= 0) {
        this.emptyResponse = true;
      } else if(this.allResponses.length != 0) {
        this.emptyResponse = false;
      }
      this.spinner= false;
    })
  }

  addResponse() {
    this.spinner = true;
    let obj = {response: this.response, response_question_id: this.data.resource_question_id, resource_id: this.data.resource_id};
    this._resourcesServices.addQuestionResponse(obj).subscribe(data => {
      if (data.success) {
        this.log
          .addLog({
          action: "Add",
          component: "Add Response",
          details: `Gave an answer to question with title ${this.data.question_title} in Resources ${this.data.resource}`,
        }).subscribe(data => { });
        this.ngOnInit();
      } else {
        this.constr.snackBar.open("Failed", 'Dismiss');
      }
      this.response = "";
      this.spinner = false;
    })
  }


}
